var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewer-container",attrs:{"id":"viewer-container"}},[_c('div',{staticClass:"pdfViewer",attrs:{"id":"viewer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }